function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m54.567 389.197v63h16.867v-27.283h36.212v27.283h16.867v-63h-16.867v22.819h-36.212v-22.819z"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m313.019 389.197v13.394h24.307v49.607h16.865v-49.607h24.309v-13.394z"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m451.917 389.197v13.394h-44.646v9.425h37.701v12.898h-37.701v13.889h44.646v13.395h-61.513v-63.001z"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m231.663 389.197h17.858l34.725 43.158v-43.158h17.363v63.001h-19.843l-33.237-41.174v41.173h-16.866z"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m178.088 438.803c10.914 0 17.858-3.968 17.858-12.897v-36.709h16.866v39.686c0 16.37-16.37 24.803-35.717 24.803-18.851 0-34.725-8.433-34.725-24.803v-39.686h16.866v36.709c.497 8.93 7.939 12.897 18.852 12.897"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("text", {
  fontFamily: "'MyriadPro-Regular'",
  fontSize: 59.528,
  transform: "translate(1476.4956 2385.0994)"
}, "EAE6DE");

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m0 296.928v247.537h594.289v-247.537zm569.484 222.735h-544.681v-197.931h544.681z"
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m521.863 427.89c10.418-1.488 15.377-9.426 15.377-19.843 0-10.418-8.928-18.354-19.346-18.354h-50.6v63h16.867v-23.811h17.361l18.852 23.811h21.33zm-7.442-12.402h-30.26v-13.89h30.26c8.434 0 8.434 13.89 0 13.89z"
});

var SvgHunter = function SvgHunter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 296.928 595.281 247.537",
    viewBox: "0 296.928 595.281 247.537",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHunter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "hunter.svg";
export { ForwardRef as ReactComponent };